module.exports = __webpack_public_path__ + "static/media/hamamo_bottom_logo_delivery.9a92fa99.png";